import { suffix } from 'retinable';
import { takeLatest, call } from 'redux-saga/effects';
import { LOCATION_CHANGE } from 'react-router-redux';
import request from '../api-utils/request';
import actionKey from '../utils/action-key';
import ignoreEmptyValues from '../utils/ignore-empty';
import SITE_MODES from '../../constants/site-modes';

const defaultState = {
    primaryColor: '#333',
    accentColor: '#666',
    logo: '',
    poweredBy: '',
};

export const FETCH_THEME = 'theme/FETCH_THEME';

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case actionKey.success(FETCH_THEME): {
            const {
                theme,
                company,
                haveCoupons,
            } = action.payload;
            const logo = theme.siteMode === SITE_MODES.EDUCATION ? 'pathwayu' : 'jobzology';
            return {
                ...state,
                ...ignoreEmptyValues(theme),
                ...company,
                poweredBy: `/img/${logo}-logo${suffix()}.png`,
                connectMode: company.companyDomain === 'ubeu' || company.companyDomain === 'spartan' || company.companyDomain === 'petersons' || company.companyDomain === 'nustaredu',
                jobsFeed: !!theme.jobsFeed,
                price: theme.price,
                haveCoupons,
                customProgramText: theme.customProgramText,
                customProgramUrl: theme.customProgramUrl,
                customProgramLinkText: theme.customProgramLinkText,
            };
        }
        default:
            return state;
    }
};

export function* rootSaga() {
    yield takeLatest(LOCATION_CHANGE, fetchTheme);
}

export function* fetchTheme() {
    yield call(request, {
        type: FETCH_THEME,
        url: '/api/theme',
    });
}

export default reducer;



// WEBPACK FOOTER //
// ./src/client/redux/theme.js